module.exports = __webpack_public_path__ + "img/banner-1.9689a5c5.png";